export { default } from "./pageStructures.api";
export * from "./pageStructures.api.type";
